import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopic4/etiquetas.glb";
import { GUI } from "dat.gui";

export class Etiquetas extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);

		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.helpers();
		this.observerListtneners();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Etqueta_nueva = gltf.scene.getObjectByName("Etqueta_nueva", true);
			this.Etiqueta_vieja = gltf.scene.getObjectByName("Etiqueta_vieja", true);

			this.allEtiquetas = {
				Etqueta_nueva: {
					p: this.Etqueta_nueva.position.clone(),
					r: this.Etqueta_nueva.rotation.clone(),
				},
				Etiqueta_vieja: {
					p: this.Etiqueta_vieja.position.clone(),
					r: this.Etiqueta_vieja.rotation.clone(),
				}
			}
		});
	}

	setPositionEtiquetas() {
		Object.entries(this.allEtiquetas).forEach(([key, value]) => {
			this[key].position.copy(value.p)
			this[key].rotation.copy(value.r)
		})
	}

	onChangeNewEtiquetaPosition() {
		this.Etiqueta_vieja.visible = false;
		this.Etqueta_nueva.position.copy(this.Etiqueta_vieja.position);
		this.Etqueta_nueva.rotation.copy(this.Etiqueta_vieja.rotation);
	}

	observerListtneners() { }

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("etiquetas");
		premiaFolder.add(this.position, "x", -10, 10).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -10, 10).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -10, 10).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		// premiaFolder.open();
	}

	renderAnimations() { }
}
